import CommonToolbar from "../../../UIElements/CommonToolbar";
import Cookies from "js-cookie";
import { DisplayErrors } from "../../../../Utils/ErrorHandler";
import EnumsContext from "../../../../context/enums-context";
import { currencyEditor, numberEditorWithMeasurements, priceEditor, textEditor } from "../../../../Utils/TableEditors";
import { findKeyByValue, formatCurrency, formatDate, formatQuantityWithMeasurement, useEnumLabel } from "../../../../Utils/Utils";
import DropdownInput from "../../../UIElements/Inputs/DropdownInput";
import HistoryElement from "../../../UIElements/HistoryElement";
import { orderStatusesTranslation, Translate } from "../../../../Utils/TranslationUtils";
import ProductsAndServicesPickerSidebar from "../../../UIElements/ProductsAndServicesPickerSidebar";
import useApi from "../../../../Utils/BackendClient";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useFormik } from "formik";
import useGetEnums from "../../../../Utils/EnumsUtils";
import { useLocation, useNavigate } from "react-router-dom";
import { useIsMobile } from "../../../../Utils/ResizeUtils";
import ExternalProductSidebarPicker from "../../../UIElements/ExternalProductSidebarPicker";
import ExternalActDetailsContent from "./ExternalActDetailsContent";
import ReceptionActDetailsContent from "../Accounting/ReceptionActDetailsContent";

import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { ConfirmPopup, confirmPopup } from "primereact/confirmpopup";
import { DataTable } from "primereact/datatable";
import { FloatLabel } from "primereact/floatlabel";
import { Guid } from "js-guid";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { Menu } from "primereact/menu";
import { Sidebar } from "primereact/sidebar";
import { TabMenu } from "primereact/tabmenu";
import { Toast } from "primereact/toast";
import { Tooltip } from "primereact/tooltip";

import commonStyle from "../../CommonStyles.module.css";
import SaleActDetailsContent from "./SaleActDetailsContent";

const OrderDetails = () => {

    const { createOrder, createOrderComment, deleteOrderComment, fetchOrderActs, fetchOrderComments, fetchOrderDetails, fetchOrderHistory, fetchRemainings, updateOrder } = useApi();

    const ctx = useContext(EnumsContext);
    const isMobile = useIsMobile();
    const location = useLocation();
    const navigate = useNavigate();
    const toast = useRef();
    const actMenu = useRef(null);

    const [actData, setActData] = useState(null);
    const [actsLazyState, setActsLazyState] = useState({
        first: 0,
        rows: 10,
        page: 1
    });
    const [actSbVisible, setActSbVisible] = useState(false);
    const [actType, setActType] = useState(null);
    const [bookedQuantity, setBookedQuantity] = useState(0);
    const [bookingSbVisible, setBookingSbVisible] = useState(false);
    const [commentsLazyState, setCommentsLazyState] = useState({
        first: 0,
        rows: 10,
        page: 1
    });
    const [expandedRows, setExpandedRows] = useState([]);
    const [exSbVisible, setExSbVisible] = useState(false);
    const [historyLazyState, setHistoryLazyState] = useState({
        first: 0,
        rows: 10,
        page: 1
    });
    const [loading, setLoading] = useState(false);
    const [newComment, setNewComment] = useState(null);
    const [orderActs, setOrderActs] = useState(null);
    const [orderActsTotalRecords, setOrderActsTotalRecords] = useState(0);
    const [orderComments, setOrderComments] = useState(null);
    const [orderCommentsTotalRecords, setOrderCommentsTotalRecords] = useState(0);
    const [orderDetails, setOrderDetails] = useState({
        division_id: null,
        client_id: null,
        status: "NEW",
        manager_id: +Cookies.get("userId"),
        order_products: [],
        order_services: []
    });
    const [orderHistory, setOrderHistory] = useState(null);
    const [orderHistoryTotalRecords, setOrderHistoryTotalRecords] = useState(0);
    const [orderId, setOrderId] = useState(null);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [selectedServices, setSelectedServices] = useState([]);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [tabShowed, setTabShowed] = useState(0);
    const [type, setType] = useState(null);
    const [visible, setVisible] = useState(false);
    const [selectedElement, setSelectedElement] = useState(null);

    const enumTypes = useMemo(() => ["divisions", "clients", "partners", "users"], []);

    useGetEnums(enumTypes);

    const getPartnerLabel = useEnumLabel(ctx.enums.partners.data);

    useEffect(() => {
        if (location.state !== null) {
            if (location.state.id) {

                setOrderId(location.state?.id);

                const fetchAmountInStorage = async (id) => {
                    const request = {
                        page: 1,
                        rows: 10,
                        filters: {
                            product: { value: id }
                        }
                    };

                    const response = await fetchRemainings(request);

                    if (response.status === 200) {
                        if(response.data.results.length > 0){
                            return response.data.results[0].total_quantity;
                        }
                        else{
                            return 0;
                        }
                    }
                }

                const fetchData = async () => {

                    setLoading(true);

                    const response = await fetchOrderDetails(location.state.id);

                    if (response.status === 200) {

                        const data = response.data;

                        const assignGuids = (items) => {
                            items?.forEach(item => item.feId = Guid.newGuid().toString());

                            if (items) {
                                items.forEach(element => {
                                    element.external_products?.forEach(item => item.feId = element.feId);
                                });
                            }
                        };

                        if (response.data.order_products?.length > 0) {
                            for (const product of response.data.order_products) {
                                if (product.product_id) {
                                    const amount = await fetchAmountInStorage(product.product_id);
                                    product.storageQuantity = amount;
                                }
                            }
                        }

                        assignGuids(data.order_products);
                        assignGuids(data.order_services);

                        setOrderDetails(response.data);

                        setExpandedRows(response.data.order_products);

                        setLoading(false);
                    }
                    else {
                        toast.current.show({ severity: "error", summary: "Помилка отримання даних акту", detail: "Дані акту не отримано. Помилка сервера: " + response.status, life: 3000 });
                    }
                }

                fetchData();
            }
        }
    }, [fetchRemainings, fetchOrderDetails, location.state]);

    const formik = useFormik({
        initialValues: orderDetails,
        enableReinitialize: true,
        validate: values => {
            const errors = {};

            if(!values.division_id){
                errors.division_id = "Виберіть точку продажу зі списку"
            }

            if(!values.client_id){
                errors.client_id = "Виберіть клієнта зі списку"
            }

            if(!values.status){
                errors.status = "Виберіть статус замовлення зі списку"
            }

            if(!values.manager_id){
                errors.manager_id = "Виберіть менеджера зі списку"
            }

            return errors;
        },
        onSubmit: async (values) => {

            setSubmitLoading(true);

            const response = orderId ? await updateOrder(location.state.id, values) : await createOrder(values);

            setSubmitLoading(false);

            const successStatus = orderId ? 200 : 201;

            if (response.status === successStatus) {
                console.log(response.data);
                setOrderId(response.data.id);
                toast.current.show({ severity: "success", summary: "Успіх", detail: `Акт успішно ${orderId ? "відредаговано" : "створено"}`, life: 3000 });
            }
            else {
                DisplayErrors(response.error, toast);
            }
        }
    });

    //methods
    const getOrderActs = async (id, state) => {
        const response = await fetchOrderActs(id, state);

        if (response.status === 200) {
            setOrderActs(response.data.results);
            setOrderActsTotalRecords(response.data.count);
        }
        else {
            toast.current.show({ severity: "error", summary: "Помилка отримання історії", detail: "Помилка сервера " + response.status, life: 3000 });
        }
    }

    const getOrderHistory = async (id, state) => {
        const response = await fetchOrderHistory(id, state);

        if (response.status === 200) {
            setOrderHistory(response.data.results);
            setOrderHistoryTotalRecords(response.data.count);
        }
        else {
            toast.current.show({ severity: "error", summary: "Помилка отримання історії", detail: "Помилка сервера " + response.status, life: 3000 });
        }
    }

    const getOrderComments = async (id, state) => {
        const response = await fetchOrderComments(id, state);

        if (response.status === 200) {
            setOrderComments(response.data.results);
            setOrderCommentsTotalRecords(response.data.count);
        }
        else {
            toast.current.show({ severity: "error", summary: "Помилка отримання коментарів", detail: "Помилка сервера " + response.status, life: 3000 });
        }
    }

    const addComment = async () => {

        if (newComment) {
            const request = {
                order_id: location.state.id,
                comment: newComment
            }

            const response = await createOrderComment(request);

            if (response.status === 201) {
                await getOrderComments(orderId, commentsLazyState);
                setNewComment("");
                toast.current.show({ severity: "success", summary: "Успіх", detail: `Коментар до замовлення з ID ${location.state.id} успішно збережено`, life: 3000 });
            }
            else {
                toast.current.show({ severity: "error", summary: "Помилка збереження коментаря", detail: "Помилка сервера " + response.status, life: 3000 });
            }
        }
    }

    const deleteComment = async (rowData) => {
        const response = await deleteOrderComment(rowData.id);

        if (response.status === 204) {
            await getOrderComments(orderId, commentsLazyState);
            toast.current.show({ severity: "success", summary: "Успіх", detail: `Коментар до замовлення з ID ${location.state.id} успішно видалено`, life: 3000 });
        }
        else {
            toast.current.show({ severity: "error", summary: "Помилка видалення коментаря", detail: "Помилка сервера " + response.status, life: 3000 });
        }
    }

    const confirmDelete = (event, rowData) => {
        confirmPopup({
            group: 'headless',
            target: event.currentTarget,
            message: 'Підтвердження видалення коментаря',
            icon: 'pi pi-exclamation-triangle',
            defaultFocus: 'accept',
            acceptLabel: "Так",
            rejectLabel: "Hi",
            accept: () => { deleteComment(rowData) }
        });
    }

    const onHistoryPage = (event) => {
        event.page = event.page + 1;
        getOrderHistory(orderId, event);

        setHistoryLazyState(event);
    }

    const onCommentsPage = (event) => {
        event.page = event.page + 1;
        getOrderComments(orderId, event);

        setCommentsLazyState(event);
    }

    const onActsPage = (event) => {
        event.page = event.page + 1;
        getOrderActs(orderId, event);

        setActsLazyState(event);
    }

    const AddNewItemToTheTable = (type) => {
        const fieldKey = type === "products" ? "order_products" : "order_services";

        const newItem = {
            feId: Guid.newGuid().toString(),
            description: "",
            price: null,
            currency: null,
            note: "",
        }

        if (type === "products") {
            newItem.quantity = 1;
            newItem.product_id = null;
            newItem.external_product_id = null;
            newItem.accounting_type = null;
            newItem.remaining_id = null;
        }

        const updatedItems = [...formik.values[fieldKey], newItem];

        formik.setFieldValue(fieldKey, updatedItems);

    }

    const DeleteItemFromTable = (rowData, type) => {
        const fieldKey = type === "products" ? "order_products" : "order_services";

        const updatedItems = formik.values[fieldKey].filter(item => item.feId !== rowData.feId);

        formik.setFieldValue(fieldKey, updatedItems);
    };

    const DeleteExtrenalProdFromTable = (rowData) => {
        const productIndex = formik.values.order_products.findIndex(item => item.feId === rowData.feId);

        if (productIndex === -1) return;

        const updatedProducts = [...formik.values.order_products];

        updatedProducts[productIndex] = {
            ...updatedProducts[productIndex],
            external_products: updatedProducts[productIndex].external_products.filter(
                item => item.external_product_id !== rowData.external_product_id
            )
        };

        formik.setFieldValue("order_products", updatedProducts);
    };

    const SelectionHandler = async (product) => {

        setVisible(false);
        console.log(product);
        console.log(product.accounting_type);
        const sp = selectedElement;

        if (!product.service_group) {
            sp.product_id = product.id;
            sp.accounting_type = product.accounting_type;
            sp.currency = sp.currency ?? product.currency;
            sp.price = sp.price ?? product.price;
            sp.description = product.product_name;
            sp.booked_quantity = 0;
            sp.measurement_units = product.measurement_unit

            const request = {
                page: 1,
                rows: 10,
                filters: {
                    division: { value: formik.values.division_id },
                    product: { value: product.id }
                }
            };

            const response = await fetchRemainings(request);

            if (response.status === 200) {
                sp.storageQuantity = response.data.results[0]?.total_quantity ?? 0;
            }

            const newProducts = formik.values.order_products.map(item =>
                item.feId === sp.feId ? sp : item
            );

            formik.setFieldValue("order_products", newProducts);
        }
        else {
            sp.service_id = product.id;
            sp.currency = sp.currency ?? product.currency;
            sp.price = sp.price ?? product.price;
            sp.description = product.name;

            const newProducts = formik.values.order_services.map(item =>
                item.feId === sp.feId ? sp : item
            );

            formik.setFieldValue("order_services", newProducts);
        }
    };

    const ExternalProductSelectionHandler = async (product) => {

        if (product.measurement_units !== selectedElement.measurement_units) {
            toast.current.show({ severity: "error", summary: "Помилка застосування зовнішнього товару", detail: "Одиниці виміру зовнішнього товару і прикріпленого товару з довідника не співпадають", life: 3000 });
        }
        else {
            const externalData = {};
            externalData.external_product_id = product.id;
            externalData.quantity = 1;
            externalData.external_product_name = product.name;
            externalData.external_product_price = product.price;
            externalData.external_product_currency = product.currency;
            externalData.external_product_partner_id = product.cagent_id;

            const sp = selectedElement;

            sp.price = sp.price ?? externalData.external_product_price;
            sp.currency = sp.currency ?? externalData.external_product_currency;

            externalData.feId = selectedElement.feId;

            sp.external_products = sp.external_products ?? [];
            sp.external_products.push(externalData);

            const newProducts = formik.values.order_products.map(item =>
                item.feId === sp.feId ? sp : item
            );

            formik.setFieldValue("order_products", newProducts);

            setExpandedRows([sp]);
            setExSbVisible(false);
        }

    };

    const BookProducts = () =>{
        selectedElement.booked_quantity = bookedQuantity;

        const newProducts = formik.values.order_products.map(item =>
            item.feId === selectedElement.feId ? selectedElement : item
        );

        formik.setFieldValue("order_products", newProducts);

        setBookingSbVisible(false);
    }

    const toolbarLeftData = () => {

        let name = "Створення нового замовлення";

        if (orderId) {
            name = "Редагування замовлення"
        }

        return !isMobile ? <h3>{name}</h3> : null;
    };

    const items = [
        {
            label: 'Деталі',
            icon: 'pi pi-book',
            command: () => {
                setTabShowed(0);
            },
        },
        {
            label: 'Акти',
            icon: 'pi pi-file',
            command: () => {
                setTabShowed(1);
                getOrderActs(orderId, actsLazyState);
            },
        },
        ...(orderId
            ? [{
                label: 'Історія',
                icon: 'pi pi-history',
                command: () => {
                    setTabShowed(3);
                    getOrderHistory(orderId, historyLazyState);
                },
            },
            {
                label: 'Коментарі',
                icon: 'pi pi-comment',
                command: () => {
                    setTabShowed(2);
                    getOrderComments(orderId, historyLazyState);
                },
            }] : []),
    ];

    const setTableHeader = (tablename) => {
        return (
            <div className="flex flex-wrap align-items-center justify-content-between gap-2">
                <div className={!isMobile ? "text-xl text-900 font-bold" : "font-bold"}>{Translate(tablename)}</div>
                <div>
                    <Button
                        icon="pi pi-plus"
                        type="button"
                        className={`p-button-rounded ${commonStyle.addButton}`}
                        severity="success"
                        tooltip="Додати"
                        tooltipOptions={{ showOnDisabled: true, position: "left" }}
                        onClick={() => AddNewItemToTheTable(tablename)}
                    />
                </div>
            </div>

        );
    }

    const tableActionBodyTemplate = (rowData, type) => {

        const isDisabled = !rowData.product_id;

        return (<div className="flex flex-row gap-2 justify-content-center align-items-center">
            <Button
                icon="pi pi-box"
                type="button"
                outlined
                rounded
                severity="info"
                disabled={formik.values.division_id === null}
                tooltip={!isMobile ? type === "products" ? "Прикріпити товар" : "Прикріпити послугу" : null}
                tooltipOptions={{ showOnDisabled: true, position: "left" }}
                onClick={() => {
                    setType(type);
                    setVisible(true);
                    setSelectedElement(rowData);
                }}
            />
            {type === "products" && <Button
                icon="pi pi-lock"
                type="button"
                outlined
                rounded
                severity="warning"
                tooltip={isDisabled || rowData?.storageQuantity === 0 ? "Товару немає на складі" : "Зарезервувати товар"}
                disabled={isDisabled || rowData?.storageQuantity === 0}
                className={`${isDisabled || rowData?.storageQuantity === 0 ? commonStyle.closeButton : ""}`}
                tooltipOptions={{ showOnDisabled: true, position: "left" }}
                onClick={() => {
                    setBookingSbVisible(true);
                    setSelectedElement(rowData);
                }}
            />}
            {type === "products" && <Button
                icon="pi pi-shopping-cart"
                type="button"
                outlined
                rounded
                severity="warning"
                tooltip="Зовнішній товар"
                disabled={isDisabled}
                className={`${isDisabled ? commonStyle.closeButton : ""}`}
                tooltipOptions={{ showOnDisabled: true, position: "left" }}
                onClick={() => {
                    setExSbVisible(true)
                    setSelectedElement(rowData);
                }}
            />}
            <Button
                icon="pi pi-trash"
                type="button"
                outlined
                rounded
                severity="danger"
                tooltip="Видалити"
                tooltipOptions={{ showOnDisabled: true, position: "left" }}
                onClick={() => DeleteItemFromTable(rowData, type)}
            />
        </div>
        );
    }

    const extProdsActionBodyTemplate = (rowData) => {
        return (<div className="flex flex-row gap-2 justify-content-center align-items-center">
            <Button
                icon="pi pi-trash"
                type="button"
                outlined
                rounded
                severity="danger"
                tooltip="Видалити"
                tooltipOptions={{ showOnDisabled: true, position: "left" }}
                onClick={() => DeleteExtrenalProdFromTable(rowData)}
            />
        </div>)
    }

    const commentActionBodyTemplate = (rowData) => {
        return (
            <Button
                icon="pi pi-trash"
                type="button"
                className={`p-button-rounded ${commonStyle.deleteButton}`}
                severity="danger"
                tooltip="Видалити"
                tooltipOptions={{ showOnDisabled: true, position: "left" }}
                onClick={(event) => confirmDelete(event, rowData)}
            />)
    }

    const tableIndicators = (rowData, type) => {

        const productAdded = type === "products" ? rowData.product_id || rowData.external_product_id : rowData.id;
        //const actAdded = false;
        return (<>
            <div className="flex flex-row gap-2">
                <i
                    className={`pi pi-box ${productAdded ? commonStyle.addButton : commonStyle.deleteButton} added-indicator mr-2`}
                    data-pr-tooltip={productAdded ? "Товар приєднано" : "Товар не приєднано"} data-pr-position="left"
                    id={`added-indicator-${rowData.id}`}
                />
                {/*<i
                    className={`pi pi-file ${actAdded ? commonStyle.addButton : commonStyle.deleteButton} act-indicator`}
                    data-pr-tooltip={actAdded ? "Додано до акту" : "Немає актів"} data-pr-position="left"
                    id={`act-indicator-${rowData.id}`}
                />*/}
            </div>
            <Tooltip target={`#added-indicator-${rowData.id}`} />
            <Tooltip target={`#act-indicator-${rowData.id}`} />
        </>
        )
    }

    const orderTableHeader = (
        <div className="flex flex-row">
            <InputText
                onChange={e => setNewComment(e.target.value)}
                name="amount"
                className="mr-3"
                placeholder="Введіть новий коментар"
                value={newComment}
                style={{ width: '70%' }}
            />
            <Button
                icon="pi pi-plus"
                type="button"
                className={`p-button-rounded ${newComment ? commonStyle.addButton : commonStyle.closeButton}`}
                severity="success"
                disabled={!newComment}
                tooltip="Додати коментар"
                tooltipOptions={{ showOnDisabled: true, position: "left" }}
                onClick={() => addComment()}
            />
        </div>
    )

    const internalStorageBody = (rowData) => {
        if (rowData.product_id) {
            return `${rowData.booked_quantity ?? 0}/${rowData.storageQuantity}`
        }

        return "Прикріпіть товар";
    }

    const expandedRowTemplate = (rowData) => {
        return (
            <DataTable value={rowData.external_products} emptyMessage="Немає прикріплених зовнішніх товарів">
                <Column headerStyle={{ width: '7rem' }} />
                <Column headerStyle={{ width: '4%' }} />
                <Column field="quantity" header="Кількість" editor={(options) => numberEditorWithMeasurements(options, "quantity", formik, "шт.")}
                    body={(rowData) => `${rowData.quantity} шт.`} style={{ width: '9%' }} />
                <Column field="external_product_name" header="Назва товару" style={{ width: '20%' }} />
                <Column field="external_product_price" header="Ціна" body={(rowData) => formatCurrency(rowData.external_product_price, rowData.external_product_currency ?? "UAH")} style={{ width: '10%' }} />
                <Column field="external_product_currency" header="Валюта" editor={(options) => currencyEditor(options, "order_products", formik)} style={{ width: '10%' }} />
                <Column field="external_product_partner_id" header="Контрагент" body={(rowData) => getPartnerLabel(rowData.external_product_partner_id)} />
                <Column field="action" body={(extRowData) => extProdsActionBodyTemplate(extRowData)} style={{ width: '8%' }} />
            </DataTable>);
    }

    const createActData = (extProds) => {

        const newActData = {
            partner_id: extProds?.partner,
            order_id: orderId,
            products: extProds ? extProds.products : selectedProducts,
            services: selectedServices
        };

        setActData(newActData);
    }

    const ReturnActId = (rowData) => {
        if(rowData.act_type === "PARTNER_SALE")
        {
            return rowData.external_sale_act_id;
        }

        return rowData.act_id;
    }

    const onRowSelect = (event) => {
        if(event.data.act_type === "PARTNER_SALE")
        {
            const route = '/externalacts/editexternalact/' + event.data.external_sale_act_id;
            navigate(route, { state: { id: event.data.external_sale_act_id } });     
        }
        else if(event.data.act_type === "SALE_ACT"){
            navigate("")
        }
        else{
            navigate("");
        }
    }

    const checkExistingExternalProducts = () => {
        var extProds = selectedProducts.filter(product => product.external_products?.length > 0);

        let extProdObject = {};

        if(extProds?.length > 0){
            let partner = null;
            let extProducts = [];
            extProds.forEach(product => {
                product.external_products.forEach(extProd => {
                    if(partner === null){
                        partner = extProd.external_product_partner_id;
                    }
                    else{
                        if(partner !== extProd.external_product_partner_id){
                            toast.current.show({ severity: "error", summary: "Помилка обраних товарів", detail: "Обрані товари від різних партнерів", life: 3000 });

                            return null;
                        }
                    }

                    extProd.product_id = product.id;
                });

                extProducts.push(...product.external_products);
            })

            extProdObject.partner = partner;
            extProdObject.products = extProducts;

            return extProdObject; 
        }

        toast.current.show({ severity: "error", summary: "Помилка обраних товарів", detail: "Жоден з обраних товарів не містить зовнішніх товарів", life: 3000 });
        return null;
    }

    const menuItems = [
        {
            label: 'Акт прийому',
            icon: 'pi pi-sign-in',
            command: () => {
                setActSbVisible(true);
                setActType("Reception");
                createActData();
            },
        },
        {
            label: 'Акт продажу',
            icon: 'pi pi-sign-out',
            command: () => {
                setActSbVisible(true);
                setActType("Sale");
                createActData();
            },
        },
        {
            label: 'Зовнішній акт',
            icon: 'pi pi-shopping-cart',
            command: () => {
                let extProducts = null;

                extProducts = checkExistingExternalProducts();

                if(extProducts){
                    setActSbVisible(true);
                    setActType("External");
                    createActData(extProducts); 
                }
            },
        },
    ];

    const additionalButtons = (<>
        <Button label="Cтворити акт" type="button" className={commonStyle.warningTag} disabled={selectedProducts.length === 0 && selectedServices.length === 0} onClick={(e) => actMenu.current.toggle(e)} />
        <Menu
            model={menuItems}
            popup
            ref={actMenu}
        />
    </>
    );

    console.log(formik.values);

    return (<form onSubmit={formik.handleSubmit}>
        <Toast ref={toast} />
        <CommonToolbar isMobile={isMobile} isFinalized={false} loading={submitLoading} onRetunButtonClick={() => navigate("/orders")} leftContent={toolbarLeftData()} onDocPrint={null} additionalButtons={additionalButtons} />
        <TabMenu model={items} />
        {tabShowed === 0 && <div className="grid">
            <div className={`${commonStyle.leftMenu} col-5 md:col-4 lg:col-3`}>
                <DropdownInput
                    formik={formik}
                    paramName={"division_id"}
                    context={ctx.enums.divisions.data}
                    onChange={(val) => formik.setFieldValue("division_id", val)}
                    label={"Точка продажу"} />
                <DropdownInput
                    formik={formik}
                    paramName={"client_id"}
                    context={ctx.enums.clients.data}
                    onChange={(val) => formik.setFieldValue("client_id", val)}
                    label={"Клієнт"} />
                <DropdownInput 
                    formik={formik}
                    paramName={"status"}
                    context={orderStatusesTranslation}
                    onChange={(val) => formik.setFieldValue("status", findKeyByValue(orderStatusesTranslation, val))}
                    label={"Статус"} />
                <DropdownInput 
                    formik={formik}
                    paramName={"manager_id"}
                    context={ctx.enums.users.data}
                    onChange={(val) => formik.setFieldValue("manager_id", val)}
                    label={"Менеджер"} />
            </div>
            <div className="col-7 md:col-8 lg:col-9">
                <DataTable value={formik.values.order_products} header={setTableHeader("products")} emptyMessage="Немає товарів у замовленні" editMode="cell"
                    selection={selectedProducts} onSelectionChange={(e) => {setSelectedProducts(e.value)} } selectionMode='checkbox' loading={loading}
                    onRowToggle={(e) => setExpandedRows(e.data)} expandedRows={expandedRows} rowExpansionTemplate={expandedRowTemplate} >
                    <Column expander headerStyle={{ width: '3rem' }} />
                    <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />
                    <Column field="indicators" body={(rowData) => tableIndicators(rowData, "products")} style={{ width: '4%' }} />
                    <Column field="quantity" header="Кількість" editor={(options) => numberEditorWithMeasurements(options, "quantity", formik, "шт.")} body={(rowData) => formatQuantityWithMeasurement(rowData.quantity, rowData.measurement_units ?? "PIECES")} style={{ width: '10%' }} />
                    <Column field="description" header="Опис" editor={(options) => textEditor(options, "description", "order_products", formik)} style={{ width: '20%' }} />
                    <Column field="price" header="Ціна" editor={(options) => priceEditor(options, "price", "order_products", formik)} body={(rowData) => rowData.price ? formatCurrency(rowData.price, rowData.currency ?? "UAH") : ""} style={{ width: '10%' }} />
                    <Column field="currency" header="Валюта" editor={(options) => currencyEditor(options)} style={{ width: '10%' }} />
                    <Column field="booked" header="Резерв/На складі" body={(rowData) => internalStorageBody(rowData)} style={{ width: '8%' }} />
                    <Column field="note" editor={(options) => textEditor(options, "note", "order_products", formik)} header="Коментар" style={{ width: '20%' }} />
                    <Column field="action" body={(rowData) => tableActionBodyTemplate(rowData, "products")} style={{ width: '15%' }} />
                </DataTable>
                <DataTable value={formik.values.order_services} header={setTableHeader("services")} emptyMessage="Немає послуг у замовленні" editMode="cell"
                    selection={selectedServices} onSelectionChange={(e) => setSelectedServices(e.value)} selectionMode='checkbox' loading={loading}>
                    <Column expander headerStyle={{ width: '3rem' }} />
                    <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />
                    <Column field="indicators" body={(rowData) => tableIndicators(rowData, "services")} style={{ width: '4%' }} />
                    <Column field="description" editor={(options) => textEditor(options, "description", "order_services", formik)} header="Опис" style={{ width: '30%' }} />
                    <Column field="price" header="Ціна" editor={(options) => priceEditor(options, "price", "order_services", formik)} body={(rowData) => rowData.price ? formatCurrency(rowData.price, rowData.currency ?? "UAH") : ""} style={{ width: '10%' }} />
                    <Column field="currency" header="Валюта" editor={(options) => currencyEditor(options)} style={{ width: '10%' }} />
                    <Column field="note" header="Коментар" editor={(options) => textEditor(options, "note", "order_services", formik)} style={{ width: '35%' }} />
                    <Column field="action" body={(rowData) => tableActionBodyTemplate(rowData, "services")} style={{ width: '8%' }} />
                </DataTable>
            </div>
        </div>}
        {tabShowed === 1 && <DataTable value={orderActs} stripedRows lazy rows={actsLazyState.rows} paginator onPage={onActsPage} totalRecords={orderActsTotalRecords} rowsPerPageOptions={[10, 20, 50]} first={actsLazyState.first}
                selectionMode="single" onRowSelect={onRowSelect} emptyMessage="Немає приєднаних актів до замовлення">
                <Column field="id" header="ID" body={(rowData => ReturnActId(rowData))}/>
                <Column field="act_type" header="Тип акту"  body={ rowData => Translate(rowData.act_type)} />
                <Column field="act_status" header="Cтатус акту" body={ rowData => Translate(rowData.act_status)} />
            </DataTable>}
        {tabShowed === 2 && (<>
            <DataTable value={orderComments} stripedRows lazy rows={commentsLazyState.rows} paginator onPage={onCommentsPage} totalRecords={orderCommentsTotalRecords} rowsPerPageOptions={[10, 20, 50]} first={commentsLazyState.first}
                header={orderTableHeader} emptyMessage="Немає коментарів до замовлення">
                <Column field="comment" header="Коментар" style={{ width: '70%' }} />
                <Column field="created_at" header="Дата" body={(rowData) => formatDate(rowData.created_at)} style={{ width: '10%' }} />
                <Column field="created_by" header="Користувач" style={{ width: '10%' }} />
                <Column field="action" body={(rowData) => commentActionBodyTemplate(rowData)} style={{ width: '10%' }} />
            </DataTable>
        </>)}
        {tabShowed === 3 && <HistoryElement data={orderHistory} lazyState={historyLazyState} totalRecords={orderHistoryTotalRecords} onHistoryPage={onHistoryPage} isAct={true} />}
        <ConfirmPopup group="headless" />
        <ProductsAndServicesPickerSidebar sbVisible={visible} onHide={() => setVisible(false)} type={type} onSelect={SelectionHandler} />
        <ExternalProductSidebarPicker sbVisible={exSbVisible} onHide={() => setExSbVisible(false)} context={ctx} onSelect={ExternalProductSelectionHandler} />
        <Sidebar position="right" visible={bookingSbVisible} onHide={() => setBookingSbVisible(false)} header="Резервування товарів з складу">
            <div className={commonStyle.sideBarInput}>
                <div className="p-inputgroup flex-column">
                    <FloatLabel>
                        <InputNumber
                            name="booked_amount"
                            value={selectedElement?.booked_quantity}
                            onChange={(e) => setBookedQuantity(e.value)}
                            className="w-full"
                            max={Math.min(selectedElement?.storageQuantity ?? 0, selectedElement?.quantity ?? 0 - selectedElement?.external_products?.reduce((sum, item) => sum + item.quantity, 0) ?? 0)}
                        />
                        <label>Кількість товарів</label>
                    </FloatLabel>
                    <></>
                    <label className="mt-1">Кількість товарів на складі: {selectedElement?.storageQuantity}</label>
                    <label className="mt-1">Кількість зовнішній товарів: {selectedElement?.external_products?.reduce((sum, item) => sum + item.quantity, 0) ?? 0}</label>
                </div>
            </div>
            <Button label="Зарезервувати" type="button" severity="success" className={`${commonStyle.sideBarButton} ${commonStyle.addButton}`} onClick={() => BookProducts()} autoFocus/>
        </Sidebar>
        <Sidebar visible={actSbVisible} position="right" className={commonStyle.pageSideBar} onHide={() => setActSbVisible(false)}>
            {actType === "Reception" && <ReceptionActDetailsContent ctx={ctx} orderData={actData} toast={toast}/>}
            {actType === "Sale" && <SaleActDetailsContent ctx={ctx} orderData={actData} toast={toast}/>}
            {actType === "External" && <ExternalActDetailsContent ctx={ctx} orderData={actData} toast={toast} isMobile={isMobile}/>}            
        </Sidebar>
    </form>)
};

export default OrderDetails;